import { render, staticRenderFns } from "./MbFileUpload.vue?vue&type=template&id=490fd71a&scoped=true&"
import script from "./MbFileUpload.vue?vue&type=script&lang=js&"
export * from "./MbFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./MbFileUpload.vue?vue&type=style&index=0&id=490fd71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490fd71a",
  null
  
)

export default component.exports